export default __webpack_public_path__ + "static/media/ChangeNickname.b4d5d37e.mp4";